"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = void 0;
/**
 * Basically a switch case
 * @param data
 * @param options
 */
function transform(data, options) {
    let transformed_data = data;
    if (options) {
        if (data in options.hash) {
            transformed_data = options.hash[data];
        }
        else if ('_default' in options.hash) {
            transformed_data = options.hash['_default'];
        }
    }
    return transformed_data;
}
exports.transform = transform;
